import React from 'react';
import { Twitter, Facebook, Instagram, Linkedin, Mail } from 'lucide-react';
import { Logo } from './Logo';
// Toggle social media links visibility
const SHOW_SOCIAL_MEDIA = false;
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-gray-900 text-white pt-20 pb-8" data-id="element-105">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl" data-id="element-106">
        <div className="grid md:grid-cols-4 gap-12 mb-16" data-id="element-107">
          <div data-id="element-108">
            <div className="mb-6" data-id="element-109">
              <Logo data-id="element-110" />
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed" data-id="element-111">
              The ultimate WooCommerce Conversion Toolkit. Boost your sales and
              improve customer experience with our powerful suite of tools.
            </p>
            {SHOW_SOCIAL_MEDIA && <div className="flex space-x-4" data-id="element-112">
                <a href="#" className="text-gray-400 hover:text-purple-400 transition-colors" data-id="element-113">
                  <Twitter className="h-5 w-5" data-id="element-114" />
                </a>
                <a href="#" className="text-gray-400 hover:text-purple-400 transition-colors" data-id="element-115">
                  <Facebook className="h-5 w-5" data-id="element-116" />
                </a>
                <a href="#" className="text-gray-400 hover:text-purple-400 transition-colors" data-id="element-117">
                  <Instagram className="h-5 w-5" data-id="element-118" />
                </a>
                <a href="#" className="text-gray-400 hover:text-purple-400 transition-colors" data-id="element-119">
                  <Linkedin className="h-5 w-5" data-id="element-120" />
                </a>
              </div>}
          </div>
          <div data-id="element-121">
            <h3 className="font-bold text-lg mb-6 text-white" data-id="element-122">Product</h3>
            <ul className="space-y-3" data-id="element-123">
              <li data-id="element-124">
                <a href="#features" className="text-gray-400 hover:text-white transition-colors" data-id="element-125">
                  Features
                </a>
              </li>
              <li data-id="element-126">
                <a href="#pricing" className="text-gray-400 hover:text-white transition-colors" data-id="element-127">
                  Pricing
                </a>
              </li>
              <li data-id="element-128">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-129">
                  Documentation
                </a>
              </li>
              <li data-id="element-130">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-131">
                  Changelog
                </a>
              </li>
              <li data-id="element-132">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-133">
                  Roadmap
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-134">
            <h3 className="font-bold text-lg mb-6 text-white" data-id="element-135">Company</h3>
            <ul className="space-y-3" data-id="element-136">
              <li data-id="element-137">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-138">
                  About Us
                </a>
              </li>
              <li data-id="element-139">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-140">
                  Blog
                </a>
              </li>
              <li data-id="element-141">
                <a href="mailto:support@commerceboost.io" className="text-gray-400 hover:text-white transition-colors" data-id="element-142">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-143">
            <h3 className="font-bold text-lg mb-6 text-white" data-id="element-144">Support</h3>
            <ul className="space-y-3" data-id="element-145">
              <li data-id="element-146">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-147">
                  Help Center
                </a>
              </li>
              <li data-id="element-148">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-149">
                  Community Forum
                </a>
              </li>
              <li data-id="element-150">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-151">
                  Video Tutorials
                </a>
              </li>
              <li data-id="element-152">
                <a href="mailto:support@commerceboost.io" className="flex items-center text-gray-400 hover:text-white transition-colors" data-id="element-153">
                  <Mail className="h-4 w-4 mr-2" data-id="element-154" />
                  support@commerceboost.io
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-8 mt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-155">
          <p className="text-gray-500 mb-4 md:mb-0" data-id="element-156">
            &copy; {currentYear} CommerceBoost. All rights reserved.
          </p>
          <div className="flex space-x-6" data-id="element-157">
            <a href="#" className="text-gray-500 hover:text-gray-400 transition-colors" data-id="element-158">
              Terms
            </a>
            <a href="#" className="text-gray-500 hover:text-gray-400 transition-colors" data-id="element-159">
              Privacy
            </a>
            <a href="#" className="text-gray-500 hover:text-gray-400 transition-colors" data-id="element-160">
              Cookies
            </a>
          </div>
        </div>
      </div>
    </footer>;
}